import { render, staticRenderFns } from "./SemesterTypeSave.vue?vue&type=template&id=1c2ba0d9&"
import script from "./SemesterTypeSave.vue?vue&type=script&lang=js&"
export * from "./SemesterTypeSave.vue?vue&type=script&lang=js&"
import style0 from "./SemesterTypeSave.vue?vue&type=style&index=0&id=1c2ba0d9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports